import { render } from "./summary-proposition-listing.vue?vue&type=template&id=110faf68"
import script from "./summary-proposition-listing.vue?vue&type=script&lang=js"
export * from "./summary-proposition-listing.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__